import { ACTION_POINT_INFO } from '../../providers/param/registry-keys.js';
import { ParamRegistry } from '../../registries/param-registry.js';
import { PreHandlers } from '../../registries/pre-handler-registry.js';

/**
 * 获得当前操作中的 Control 信息
 *
 * @public
 * @decorator
 */
function ActionPointInfo() {
    return ParamRegistry.decorate(ACTION_POINT_INFO);
}
PreHandlers.set(ACTION_POINT_INFO, ({ context, runner }) => (Object.assign(Object.assign(Object.assign({}, context.controllerInfo(runner.point)), runner.point), { hasRaw: runner.hasRaw })));

export { ActionPointInfo };
//# sourceMappingURL=action-point-info.js.map
